import { Provider } from '@angular/core';

import { BenchmarkingGraphPanelComponent } from 'src/app/dashboards/panels/components/graph/bench-marking-graph-panel.component';
import { DegreeDaysGraphPanelComponent } from 'src/app/dashboards/panels/components/graph/degree-days-graph-panel.component';
import { GraphComponent } from 'src/app/panels/components/graph/graph.component';
import { IndoorClimateOverviewCardPanelComponent } from '../dashboards/panels/components/card/indoor-climate-overview-card-panel.component';
import { RoomClimateCardPanelComponent } from '../dashboards/panels/components/card/room-climate-card-panel.component';
import { WeatherStationOutsideClimateCardPanelComponent } from '../dashboards/panels/components/card/weather-station-outside-climate-card-panel.component';
import { AirTemperatureGraphPanelComponent } from '../dashboards/panels/components/graph/air-temperature-graph-panel.component';
import { BatteryGraphPanelComponent } from '../dashboards/panels/components/graph/battery-graph-panel.component';
import { BenchmarkingBuildingGraphPanelComponent } from '../dashboards/panels/components/graph/bench-marking-building-graph-panel.component';
import { Co2GraphPanelComponent } from '../dashboards/panels/components/graph/co2-graph-panel.component';
import { Co2LevelGraphPanelComponent } from '../dashboards/panels/components/graph/co2-level-graph-panel.component';
import { ElectricityGraphPanelComponent } from '../dashboards/panels/components/graph/electricity-graph-panel.component';
import { GasGraphPanelComponent } from '../dashboards/panels/components/graph/gas-graph-panel.component';
import { HumidityGraphPanelComponent } from '../dashboards/panels/components/graph/humidity-graph-panel.component';
import { KnmiWeatherStationGraphPanelComponent } from '../dashboards/panels/components/graph/knmi-weatherstation-graph.component';
import { KwhPerM2GraphPanelComponent } from '../dashboards/panels/components/graph/kwh-m2-graph-panel.component';
import { OutsideClimateGraphPanelComponent } from '../dashboards/panels/components/graph/outdoor-climate-graph-panel.component';
import { SolarRadianceGraphPanelComponent } from '../dashboards/panels/components/graph/solar-radiance-graph-panel.component';
import { ThermalGraphPanelComponent } from '../dashboards/panels/components/graph/thermal-graph-panel.component';
import { WaterGraphPanelComponent } from '../dashboards/panels/components/graph/water-graph-panel.component';
import { WindSpeedGraphPanelComponent } from '../dashboards/panels/components/graph/wind-speed-graph-panel.component';
import { AvailableSunlightKpiPanelComponent } from '../dashboards/panels/components/kpi/climate/available-sunlight-kpi-panel.component';
import { Co2LevelDurationKpiPanelComponent } from '../dashboards/panels/components/kpi/climate/co2-level-durtion-kpi-panel.component';
import { CostElectricityKpiPanelComponent } from '../dashboards/panels/components/kpi/cost/cost-electricity-kpi-panel.component';
import { CostGasKpiPanelComponent } from '../dashboards/panels/components/kpi/cost/cost-gas-kpi-panel.component';
import { ActualElectricityConsumptionKpiPanelComponent } from '../dashboards/panels/components/kpi/electricity/actual-electricity-consumption-kpi-panel.component';
import { TotalElectricityChargedKpiPanelComponent } from '../dashboards/panels/components/kpi/electricity/total-electricity-charged-kpi-panel.component';
import { TotalElectricityCo2UsedKpiPanelComponent } from '../dashboards/panels/components/kpi/electricity/total-electricity-co2-used-kpi-panel.component';
import { TotalElectricityDischargedKpiPanelComponent } from '../dashboards/panels/components/kpi/electricity/total-electricity-discharged-kpi-panel.component';
import { TotalElectricityProducedKpiPanelComponent } from '../dashboards/panels/components/kpi/electricity/total-electricity-produced-kpi-panel.component';
import { TotalElectricityReturnedKpiPanelComponent } from '../dashboards/panels/components/kpi/electricity/total-electricity-returned-kpi-panel.component';
import { TotalElectricityUsedKpiPanelComponent } from '../dashboards/panels/components/kpi/electricity/total-electricity-used-kpi-panel.component';
import { TotalGreenElectricityConsumptionKpiPanelComponent } from '../dashboards/panels/components/kpi/electricity/total-green-electricity-consumption-kpi-panel.component';
import { KwhPerM2KpiPanelComponent } from '../dashboards/panels/components/kpi/environment/kwh-m2-kpi-panel';
import { TotalGasCo2UsedKpiPanelComponent } from '../dashboards/panels/components/kpi/gas/total-gas-co2-used-kpi-panel.component';
import { TotalGasUsedKpiPanelComponent } from '../dashboards/panels/components/kpi/gas/total-gas-used-kpi-panel.component';
import { PowerLimitsKpiPanelComponent } from '../dashboards/panels/components/kpi/power/power-limits-kpi-panel.component';
import { ConnectivityStatusKpiPanelComponent } from '../dashboards/panels/components/kpi/status/connectivity-status-kpi-panel.component';
import { TotalThermalUsedKpiPanelComponent } from '../dashboards/panels/components/kpi/thermal/total-thermal-used-kpi-panel.component';
import { TotalWaterUsedKpiPanelComponent } from '../dashboards/panels/components/kpi/water/total-water-used-kpi-panel.component';
import { BuildingTopPiePanelComponent } from '../dashboards/panels/components/list/building-top-list-panel.component';
import { Top10ListPanelComponent } from '../dashboards/panels/components/list/top-10-list-panel.component';
import { CategoryPiePanelComponent } from '../dashboards/panels/components/pie/category-pie-panel.component';
import { EnergyCarrierCo2PiePanelComponent } from '../dashboards/panels/components/pie/energy-carrier-co2-pie-panel.component';
import { EnergyCarrierPiePanelComponent } from '../dashboards/panels/components/pie/energy-carrier-pie-panel.component';
import { GridVsSolarPiePanelComponent } from '../dashboards/panels/components/pie/grid-vs-solar-pie-panel.component';
import { HeaderPanelComponent } from './components/header/header-panel.component';
import { SpacerPanelComponent } from './components/spacer/spacer-panel.component';

// List all panel components so that the register function gets called
const panelComponents = [
  TotalGreenElectricityConsumptionKpiPanelComponent,
  ActualElectricityConsumptionKpiPanelComponent,
  TotalElectricityUsedKpiPanelComponent,
  TotalElectricityReturnedKpiPanelComponent,
  TotalElectricityChargedKpiPanelComponent,
  TotalElectricityDischargedKpiPanelComponent,
  TotalElectricityProducedKpiPanelComponent,
  TotalElectricityCo2UsedKpiPanelComponent,
  EnergyCarrierPiePanelComponent,
  EnergyCarrierCo2PiePanelComponent,
  TotalGasUsedKpiPanelComponent,
  TotalGasCo2UsedKpiPanelComponent,
  TotalWaterUsedKpiPanelComponent,
  GridVsSolarPiePanelComponent,
  CategoryPiePanelComponent,
  Top10ListPanelComponent,
  BuildingTopPiePanelComponent,
  GraphComponent,
  ElectricityGraphPanelComponent,
  BatteryGraphPanelComponent,
  Co2GraphPanelComponent,
  GasGraphPanelComponent,
  WaterGraphPanelComponent,
  SpacerPanelComponent,
  HeaderPanelComponent,
  ConnectivityStatusKpiPanelComponent,
  PowerLimitsKpiPanelComponent,
  CostElectricityKpiPanelComponent,
  CostGasKpiPanelComponent,
  BenchmarkingGraphPanelComponent,
  BenchmarkingBuildingGraphPanelComponent,
  DegreeDaysGraphPanelComponent,
  KwhPerM2GraphPanelComponent,
  KwhPerM2KpiPanelComponent,
  AirTemperatureGraphPanelComponent,
  Co2LevelGraphPanelComponent,
  HumidityGraphPanelComponent,
  Co2LevelDurationKpiPanelComponent,
  RoomClimateCardPanelComponent,
  IndoorClimateOverviewCardPanelComponent,
  WeatherStationOutsideClimateCardPanelComponent,
  WindSpeedGraphPanelComponent,
  OutsideClimateGraphPanelComponent,
  SolarRadianceGraphPanelComponent,
  AvailableSunlightKpiPanelComponent,
  KnmiWeatherStationGraphPanelComponent,
  TotalThermalUsedKpiPanelComponent,
  ThermalGraphPanelComponent,
];

export function providePanels(): Provider[] {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (window as any).panelComponents = panelComponents;
  return [];
}
